export default {"src":"/_next/static/media/shed.1961d832.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};